import React, { Component, PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Tabs, Tab } from 'material-ui/Tabs';
import * as request from 'superagent';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';
import CircularProgress from 'material-ui/CircularProgress';
import _ from 'lodash';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";
import PhotoLibrary from "./PhotoLibrary";
import PhotoUpload from "./PhotoUpload";

const styles = {
  slideContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    height: '85%',
  }
};

class PhotosDialog extends Component {
  constructor(props) {
    super();
    this.state = {
      tabIndex: 1,
      // Photo Library
      photos: [],
      selected: [],
      // Photo upload
      isPhotoUploading: false,
      photosToUpload: [],
      photosMeta: [],
    };

    this.onPhotoSelected = this.onPhotoSelected.bind(this);
    this.submitPhotos = this.submitPhotos.bind(this);
    this.onPhotoDrop = this.onPhotoDrop.bind(this);
    this.removePhoto = this.removePhoto.bind(this);
    this.deletePhotos = this.deletePhotos.bind(this);
    this.uploadPhotos = this.uploadPhotos.bind(this);
    this.updatePhotosMetaState = this.updatePhotosMetaState.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.handleInsert = this.handleInsert.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    this.fetchPhotoList();
  }

  fetchPhotoList() {
    DataAPI.get('/api/photo', {}, (err, photos) => {
      if (err) return this.dialogs.error(err);

      this.setState({
        selected: [],
        photos,
      })
    });
  }

  handleChange(value) {
    this.setState({
      tabIndex: value,
    });
  }

  onPhotoSelected(photoToSelect) {
    let selected = _.cloneDeep(this.state.selected);

    const index = _.findIndex(selected, {
      _id: photoToSelect._id,
    });
    if (index >= 0) {
      _.pullAt(selected, [index]);
    } else {
      selected.push(photoToSelect);
    }

    this.setState({
      selected
    });
  }

  handleInsert() {
    if (this.state.tabIndex === 0) {
      this.submitPhotos();
    } else {
      this.uploadPhotos((err, photosUploaded) => {
        if (err) return this.dialogs.error(err);

        this.props.handleSubmit(photosUploaded);
      });
    }
  }

  handleClose() {
    this.props.handleClose();
    this.setState({
      photosToUpload: [],
      photosMeta: [],
    });
  }

  submitPhotos() {
    // if (_.size(this.state.selected) > this.props.maxNoOfPhotosSelectable) return this.dialogs.error(`最多只可選擇${this.props.maxNoOfPhotosSelectable}張相片`);

    this.props.handleSubmit(this.state.selected);
    this.setState({
      selected: [],
    });
  }

  async uploadPhotos(cb) {
    if (_.size(this.state.photosToUpload) > this.props.maxNoOfPhotosUploadable)
      return cb(`最多只可上戴${this.props.maxNoOfPhotosUploadable}張相片`);

    this.setState({ isPhotoUploading: true });

    let photoUploadReq = request
      .post('/api/photo/upload')
      .set('enctype', 'multipart/form-data');

    _.forEach(this.state.photosToUpload, photoToUpload => {
      photoUploadReq = photoUploadReq.attach('photo', photoToUpload);
    });

    try {
      const results = await photoUploadReq;
      const photosUploaded = results.body;

      const photosToCreate = _.map(photosUploaded, (photoUploaded, index) => {
        return {
          title: this.state.photosMeta[index].title,
          fileName: photoUploaded.filename,
        };
      });

      const reqBody = {
        photos: photosToCreate,
      };
      DataAPI.put('/api/photo/create', reqBody, (err, photosCreated) => {
        if (err) return cb(err);

        this.setState({
          photosToUpload: [],
          photosMeta: [],
          isPhotoUploading: false,
        });
        this.dialogs.alert({
          title: '上載成功',
        });
        this.fetchPhotoList();

        cb(null, photosCreated);
      });
    } catch (err) {
      return cb(err);
    }
  }

  readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = event => {
        resolve(event.target.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async onPhotoDrop(photos) {
    try {
      const base64s = await Promise.all(_.map(photos, this.readFile));

      let photosToUpload = _.cloneDeep(this.state.photosToUpload);
      let photosMeta = _.cloneDeep(this.state.photosMeta);

      photosToUpload = _.concat(photosToUpload, photos);
      const photosMetaToAdd = _.map(base64s, base64 => {
        return {
          url: base64,
          title: '',
        };
      });
      photosMeta = _.concat(photosMeta, photosMetaToAdd);

      this.setState({
        photosToUpload,
        photosMeta
      });
    } catch (err) {
      this.dialogs.error(err);
    }
  }

  updatePhotosMetaState(field, index, event, value) {
    let photosMeta = _.cloneDeep(this.state.photosMeta);
    _.assign(photosMeta[index], {
      [field]: value
    });
    this.setState({ photosMeta });
  }

  removePhoto(index) {
    let photosToUpload = _.cloneDeep(this.state.photosToUpload);
    let photosMeta = _.cloneDeep(this.state.photosMeta);

    _.pullAt(photosToUpload, [index]);
    _.pullAt(photosMeta, [index]);

    this.setState({
      photosToUpload,
      photosMeta,
    });
  }

  deletePhotos() {
    this.dialogs.confirm({
      title: '確認刪除這些圖片？',
    }, () => {
      DataAPI.delete('/api/photo', this.state.selected, (err, photosDeleted) => {
        if (err) return this.dialogs.error(err);

        this.fetchPhotoList();
      });
    });
  }

  render() {
    let actions = [];

    if (this.state.tabIndex === 0) {
      actions.push(
        <FlatButton
          label="刪除"
          secondary={true}
          onClick={this.deletePhotos}
          className="delete-btn"
          disabled={!_.size(this.state.selected)}
        />
      );
    }

    actions.push(<FlatButton
      label="取消"
      primary={true}
      onClick={this.handleClose}
    />);


    if (this.state.tabIndex === 0) {
      actions.push(
        <FlatButton
          label="插入"
          primary={true}
          disabled={!_.size(this.state.selected)}
          onClick={this.handleInsert}
        />
      )
    } else {
      actions.push(
        <FlatButton
          label={this.props.isUploading ? "上載中....." : "上載並插入"}
          icon={this.state.isPhotoUploading ?
            <CircularProgress size={25} /> : <FileUploadIcon />}
          disabled={_.size(this.state.photosMeta) === 0 || this.state.isPhotoUploading}
          primary={true}
          onClick={this.handleInsert}
        />
      )
    }

    return (
      <div>
        <Dialog
          actions={actions}
          modal={false}
          open={this.props.open}
          // autoScrollBodyContent={true}
          autoDetectWindowHeight={false}
          bodyClassName="photo-dialog"
          actionsContainerClassName="photo-actions-block"
        >
          <div>
            <div>
              <Tabs
                onChange={this.handleChange}
                value={this.state.tabIndex}
                contentContainerStyle={styles.slideContainer}
              >
                <Tab label="圖片庫" value={0}>
                  <div>
                    <PhotoLibrary onSelected={this.onPhotoSelected}
                                  photos={this.state.photos}
                                  selected={this.state.selected} />
                  </div>
                </Tab>
                <Tab label="上載" value={1}>
                  <div>
                    <PhotoUpload onDrop={this.onPhotoDrop}
                                 onPhotoUpload={this.uploadPhotos}
                                 onPhotoRemove={this.removePhoto}
                                 onPhotosMetaChange={this.updatePhotosMetaState}
                                 photosMeta={this.state.photosMeta}
                                 isUploading={this.state.isPhotoUploading} />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </Dialog>
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

PhotosDialog.propTypes = {
  open: PropTypes.bool,
  maxNoOfPhotosSelectable: PropTypes.number,
  maxNoOfPhotosUploadable: PropTypes.number,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
};

PhotosDialog.defaultProps = {
  open: false,
  maxNoOfPhotosSelectable: 0,
  maxNoOfPhotosUploadable: 0,
  handleSubmit: () => {
  },
  handleClose: () => {
  },
};

export default PhotosDialog;


// WEBPACK FOOTER //
// client/adminPanel/panel/displays/PhotosDialog.js